import http from '../../../Services/common/http-common'
import { ICatProducto } from "../Interfaces/ICatProducto"

class CatProductosServices {

    Get() {
         return http.get<ICatProducto[]>('/CatProductos/Get')
    }
    Append(data: ICatProducto) {
         return http.post<ICatProducto[]>('/CatProductos/Append', data)
    }
     Toggle(id: number) {
         return http.get<boolean>(`/CatProductos/Toggle?id=${id}`)
     }
}
export default new CatProductosServices()